
// 成本费用明细
import TableList from "@components/templates/tablelist";
import { HttpCostDetailList } from "@/service/fedex";
import { mapGetters } from "vuex";
import comExcel from '@components/templates/excelalert'
// import mixin from "../mixin";
export default {
    mixins: [TableList],
    components: {
        comExcel
    },
    data() {
        return {
            isMixin: true,
            Tools: { show: true },
            Tabs: { show: true },
            formData: {},
            Searchs: {
                show: true,
                labelWidth: 110,
            },
            Plugins: { show: true }
        };
    },
    methods: {
        ajaxRequest: HttpCostDetailList,
        handleOperates(params = "", type, batch) {
            if (batch === true) {
                params = (params || this.checkedData.join(',')) + '';
                if (!params.length) return this.$VMessage.warning(this.$t('global.common.choose_one',{defaultValue:'请选择至少一条数据'}));
            }
            switch (type) {
                case 'export':
                    this.handleWebfs(process.env.VUE_APP_APIURL_FBB + '/api/v2/costSettlement/item/export', this.formData, {
                        executor:'request',
                        download:true,
                        method:'get',
                    }).then(res => {
                        this.operate = {
                            title: this.$t('global.common.export', { defaultValue: '导出' }),
                            show: true,
                            width: 560,
                            component: "comExcel",
                            showFooter: false
                        }
                    })
                    break;
            }
        },
    },
    computed: {
        ...mapGetters('dictionary', ['getBillcusorgList', 'getBillcusWareList', 'getCusproductList','getCarrierServiceList', 'getCarrierServiceAllList']),
        ToolsData() {
            return [
                {
                    name: this.$t('fbb.alloment.muti_export',{defaultValue:'批量导出'}),
                    operate: "export",
                    theme: "primary",
                },
            ]
        },
        SearchsData() {
            return [
                {
                    label: "Tracking NO",
                    tag: 'vInput',
                    key: 'EQ_trackingNo',
                    show: true,
                },
                {
                    label: this.$t('erp.b2border.invoice',{defaultValue:'发票号'}),
                    tag: 'vInput',
                    key: 'EQ_invoiceNo',
                    show: true,
                    props: {
                        filterable: true,
                    }
                },
                {
                    label: this.$t('fbb.bill.freeze_createdat',{defaultValue:'创建日期'}),
                    tag: 'vDatepicker',
                    style: "width:250px",
                    key: 'BT_createdAt',
                    show: true,
                    props: {
                        format: 'yy-mm-dd ~ yy-mm-dd',
                        confirm: false,
                    },
                },
                {
                    label: this.$t('bi.work.task_org_id',{defaultValue:'组织'}),
                    tag: 'vSelect',
                    key: 'EQ_orgId',
                    more: true,
                    options: this.getBillcusorgList,
                    props: {
                        filterable: true,
                    }
                },
                {
                    label: this.$t('global.common.project',{defaultValue:'项目'}),
                    tag: 'vSelect',
                    key: 'EQ_lineId',
                    options: this.getCusproductList,
                    props: {
                        filterable: true,
                    }
                },
                {
                    label: this.$t('erp.b2c.product_orgwarehouse',{defaultValue:'仓库'}),
                    tag: 'vSelect',
                    key: 'EQ_orgWarehouseCode',
                    options: this.getBillcusWareList.map(item=>{
                        return {
                            value: item.attach.code,
                            label: item.label
                        }
                    }),
                    props: {
                        filterable: true,
                    }
                },
                {
                    label: this.$t('fbb.alloment.carrier_server',{defaultValue:'承运商服务'}),
                    // label: "承运商服务",
                    tag: 'vSelect',
                    key: 'EQ_carrierServiceCode',
                    options: this.getCarrierServiceAllList.map(item=>{
                        return {
                            value: item.attach.carrierServiceCode,
                            label:item.label
                        }
                    }),
                    props: {
                        filterable: true,
                    }
                },
                {
                    label: this.$t('fbb.alloment.carrier_code',{defaultValue:'承运商'}),
                    tag: 'vSelect',
                    key: 'EQ_carrierCode',
                    more: true,
                    options: [
                        {value:'FedEx',label:'FedEx'},
                        {value:'UPS',label:'UPS'},
                    ],
                    props: {
                        filterable: true,
                    }
                },
                {
                    label: this.$t('fbb.fedexcost.ismarkup',{defaultValue:'是否增加系统计费'}),
                    tag: 'vSelect',
                    key: 'EQ_markup',
                    more: true,
                    options: [
                        {value:1,label: this.$t('erp.global.yes',{defaultValue:'是'})},
                        {value:0,label: this.$t('erp.global.no',{defaultValue:'否'})},
                    ],
                    props: {
                        filterable: true,
                    }
                },
                {
                    label: this.$t('fbb.fedexcost.source_order',{defaultValue:'来源订单'}),
                    tag: 'vInput',
                    key: 'EQ_sourceNo',
                },
                {
                    label: this.$t('fbb.fedex.account',{defaultValue:'结算账户'}),
                    tag: 'vInput',
                    key: 'EQ_account',
                },
                {
                    label: this.$t('fbb.fedex.settlementMonth',{defaultValue:'核算月份'}),
                    key: 'EQ_settlementMonth',
                    tag: 'vDatepicker',
                    props: {
                        format: 'yy-mm',
                        confirm: false,
                    },
                },
            ]
        },
        columns() {
            return [
            {
                title: 'Tracking NO',
                key: 'trackingNo',

            },
            {
                title: this.$t('fbb.billDelivery.costName',{defaultValue:'收费项'}),
                key: 'costName',
            },
            {
                title: this.$t('fbb.adjustment.list_cost',{defaultValue:'收费金额'})+'/'+this.$t('erp.product.currency',{defaultValue:'币种'}),
                render:(h,{row})=>{
                    return <div>
                        <div>{row.cost || '--'} {row.currency || '--'}</div>
                    </div>
                }
            },
            {
                title: this.$t('fbb.fedexcost.source_order',{defaultValue:'来源订单'}),
                key: 'sourceNo',
            },
            {
                title: this.$t('bi.work.task_org_id',{defaultValue:'组织'})+'/'+this.$t('erp.b2c.product_orgwarehouse',{defaultValue:'仓库'})+'/'+this.$t('global.common.project',{defaultValue:'项目'}),
                key: 'orgName',
                render:(h,{row})=>{
                    let orgWarehouseCode = row.orgWarehouseCode
                    let orgWarehouse = this.getBillcusWareList.find(item=>{
                        return item.attach.code == orgWarehouseCode
                    })
                    return <div>
                        <div>{row.orgName}</div>
                        <div>{orgWarehouse ? orgWarehouse.label : '--'}</div>
                        <div>{row.lineName}</div>
                    </div>
                }
            },
            {
                title: this.$t('fbb.alloment.carrier_server',{defaultValue:'承运商服务'}),
                // title: "承运商服务",
                key: 'carrierServiceCode',
            },
            {
                title: this.$t('fbb.alloment.carrier_code',{defaultValue:'承运商'}),
                key: 'carrierCode',
            },
            {
                title: this.$t('fbb.fedex.nowmarkup',{defaultValue:'是否系统计费'}),
                render(h,{row}){
                    switch(row.markup){
                        case 1:return this.$t('erp.global.yes',{defaultValue:'是'});break;
                        case 0:return this.$t('erp.global.yes',{defaultValue:'否'});break;
                    }
                }
            },
            {
                title: this.$t('fbb.fedex.account',{defaultValue:'结算账户'}),
                key: 'account',
            },
            {
                title: this.$t('fbb.fedex.settlementMonth',{defaultValue:'核算月份'}),
                key: 'settlementMonth',
            },
            {
                title: this.$t('erp.b2border.invoice',{defaultValue:'发票号'}),
                key: 'invoiceNo',
            },
            {
                title: this.$t('fbb.fedex.import_time',{defaultValue:'导入时间'}),
                key: 'createdAt',
            },
            ];
        },

    },

};
